import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileNotesSection from '/component/partial/profile/ProfileNotesSection';
import {withTranslation} from '/provider/TranslationProvider';
import {notesById, notesUpdatedTsById} from '/redux/selector/client.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      notes: notesById,
      notesUpdatedTs: notesUpdatedTsById,
    }),
  ),
  withTranslation('screen.clientProfile.section.notes'),
)(ProfileNotesSection);
